<mat-card appearance="outlined" class="card">
  @if (editMode) {
  <mat-card-title mat-dialog-title i18n>Edit {{ title }}</mat-card-title>
  } @if (!editMode) {
  <mat-card-title mat-dialog-title i18n>Enter New {{ title }}</mat-card-title>
  }

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex-col space-between-none">
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>{{ title }} name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>External Id (opt.)</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
        @if (title==='Status' || title==='Priority') {
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>Meta Id</mat-label>
          <input matInput type="number" formControlName="metaId" />
        </mat-form-field>
        } @if (title==='User Attribute') {
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>Render Tag</mat-label>
          <input matInput formControlName="renderTag" />
        </mat-form-field>
        }
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid || form.pristine"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </div>
  </mat-card-actions>
</mat-card>
